import { render } from "./EditCustomer.vue?vue&type=template&id=1c3269a8&scoped=true&ts=true"
import script from "./EditCustomer.vue?vue&type=script&lang=ts"
export * from "./EditCustomer.vue?vue&type=script&lang=ts"

import "./EditCustomer.vue?vue&type=style&index=0&id=1c3269a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c3269a8"]])

export default __exports__